import { IConfigurationVM } from '@pm-ui/core-services';
import { environment } from '../../environments/environment';

const ConfigurationFactory = (): IConfigurationVM => {
  return Object.freeze({
    baseApiUrl: environment.baseApiUrl,
    encryptionKey: environment.encryptionKey,
    //mapApiKey: environment.mapApiKey,
    // placesApiKey: environment.placesApiKey,
    // drugsEndpoints: environment.drugsEndpoints,
    // payPalClientId: environment.payPalClientId
  });
};

export { ConfigurationFactory };
